// extracted by mini-css-extract-plugin
export var actionButton = "_cf-0";
export var attachmentLine = "_cf-1";
export var fileInput = "_cf-2";
export var fileUploadWrapper = "_cf-4";
export var footer = "_cf-3";
export var modalContent = "_cf-5";
export var paperclip = "_cf-6";
export var quillEditor = "_cf-7";